export enum CancellationFlowScreen {
	QUESTIONNAIRE = 'QUESTIONNAIRE',
	RETENTION = 'RETENTION',
	OFFER = 'OFFER',
	OFFER_SUCCESS = 'OFFER_SUCCESS',
	CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
	CANCELLATION_SUCCESS = 'CANCELLATION_SUCCESS',
	ERROR = 'ERROR',
}

export enum RetentionScreenType {
	FEATURES = 'FEATURES',
	EFFICACY = 'EFFICACY',
	GOAL_BASED_CONTENT = 'GOAL_BASED_CONTENT',
}

export enum CancellationReason {
	DIFFICULT_CONTENT_ACCESS = "can't find content easily",
	IRRELEVANT_CONTENT = 'not finding relevant content',
	INADEQUATE_CONTENT = 'not enough content',
	NO_PERSONAL_PROGRESS = 'not enough personal progress',
	INFREQUENT_USAGE = "don't use it enough",
	EXPENSIVE_PRICE = 'too expensive',
	NO_LONGER_NEEDED = 'no longer need',
}
